import request from '@/utils/request';

const base = '/sc-agent-runner/api/discount-conversion';

async function requestData(options) {
  const response = await request(options);
  const body = response.data;
  if (!body || body.success !== true) {
    throw new Error((body && (body.message || body.error)) || '请求失败，请重试');
  }
  return body.data;
}

export function getRequirements(params) {
  return requestData({ url: `${base}/requirements`, method: 'get', params });
}

export function createRequirement(data) {
  return requestData({ url: `${base}/requirements`, method: 'post', data });
}

export function updateRequirement(id, data) {
  return requestData({ url: `${base}/requirements/${id}`, method: 'post', data });
}

export function getTasks(params) {
  return requestData({ url: `${base}/tasks`, method: 'get', params });
}

export function getTask(id) {
  return requestData({ url: `${base}/tasks/${id}`, method: 'get' });
}

export function downloadTaskResultFiles(id) {
  return request({ url: `${base}/tasks/${id}/result-files/download`, method: 'get', responseType: 'blob' });
}

export function createTask(data) {
  return requestData({ url: `${base}/tasks`, method: 'post', data });
}
